import { Link } from "react-router-dom";
import niozLogo from "./assets/nioz-logo-eng.png";
import uuLogo from "./assets/uu-logo-color.png";
import uuLogoDark from "./assets/uu-logo-color-dark.png";

export const Footer = () => {
    const env = import.meta.env;

    return (
        <footer className="mt-auto w-full border-t border-line bg-surface-2">
            <div className="nz-bar opacity-80" />
            <div className="mx-auto w-full max-w-[1680px] px-4 py-8 sm:px-6">
                <div className="flex flex-col gap-8 md:flex-row md:items-start md:justify-between">

                    <div className="max-w-sm">
                        <div className="mb-2.5 flex items-center gap-2.5">
                            <span className="flex items-center justify-center rounded dark:bg-white dark:px-1.5 dark:py-1">
                                <img src={niozLogo} alt="NIOZ Royal Netherlands Institute for Sea Research" className="h-12 w-auto" />
                            </span>
                            <span className="text-sm font-bold text-ink">Dutch Marine Science Portal</span>
                        </div>
                        <div className="mb-3">
                            <img src={uuLogo} alt="Utrecht University" className="h-10 w-auto dark:hidden" />
                            <img src={uuLogoDark} alt="Utrecht University" className="hidden h-10 w-auto dark:block" />
                        </div>
                        <p className="text-[13px] leading-relaxed text-ink-3">
                            FAIR marine research data from NIOZ, Utrecht University and partner institutes.
                        </p>
                    </div>

                    <div className="grid grid-cols-2 gap-x-12 gap-y-6 sm:grid-cols-3">
                        <div>
                            <div className="nz-label mb-2.5">Portal</div>
                            <ul className="flex flex-col gap-1.5 text-[13px]">
                                <li><Link className="text-ink-2 hover:text-brand" to="/results">Search data</Link></li>
                                <li><Link className="text-ink-2 hover:text-brand" to="/basket">Download basket</Link></li>
                                <li><a className="text-ink-2 hover:text-brand" href={`${env.VITE_API_URL}/docs`} target="_blank" rel="noopener noreferrer">API reference</a></li>
                            </ul>
                        </div>
                        <div>
                            <div className="nz-label mb-2.5">About</div>
                            <ul className="flex flex-col gap-1.5 text-[13px]">
                                <li><Link className="text-ink-2 hover:text-brand" to="/page/nioz">NIOZ</Link></li>
                                <li><Link className="text-ink-2 hover:text-brand" to="/page/uu">Utrecht University</Link></li>
                                <li><Link className="text-ink-2 hover:text-brand" to="/page/mission">Portal mission</Link></li>
                            </ul>
                        </div>
                        <div>
                            <div className="nz-label mb-2.5">Support</div>
                            <ul className="flex flex-col gap-1.5 text-[13px]">
                                <li><Link className="text-ink-2 hover:text-brand" to="/page/share-data">Deposit data</Link></li>
                                <li><Link className="text-ink-2 hover:text-brand" to="/page/cite-data">How to cite</Link></li>
                                <li><a className="text-ink-2 hover:text-brand" href="mailto:rdm@nioz.nl">rdm@nioz.nl</a></li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="mt-8 flex flex-col gap-2 border-t border-line-2 pt-4 text-[11.5px] text-ink-3 sm:flex-row sm:items-center sm:justify-between">
                    <span>© {new Date().getFullYear()} NIOZ Royal Netherlands Institute for Sea Research</span>
                    <span className="nz-mono">
                        MSDP v{env.VITE_VERSION} · {env.MODE}-{env.VITE_ENV}
                    </span>
                </div>
            </div>
        </footer>
    );
};
